export const YES_NO_STATUS = [
  { value: '是', label: '是' },
  { value: '否', label: '否' }
]
export const RETURN_STATUS = [
  { value: '已入库', label: '已入库' },
  { value: '未入库', label: '未入库' }
]
export const STORE_STATUS = [
  { value: 'NIKE官方旗舰店', label: 'NIKE官方旗舰店' },
  { value: 'JORDAN官方旗舰店', label: 'JORDAN官方旗舰店' },
  { value: 'NIKE儿童官方旗舰店', label: 'NIKE儿童官方旗舰店' },
  { value: 'NIKE官方outlets店', label: 'NIKE官方outlets店' },
  { value: 'NIKE京东官方旗舰店', label: 'NIKE京东官方旗舰店' },
  { value: 'Nike-Global Swoosh官方商城/NIKE官网', label: 'Nike-Global Swoosh官方商城/NIKE官网' },
  { value: 'Nike-Global Inline官方商城/NIKE官网', label: 'Nike-Global Inline官方商城/NIKE官网' },
  { value: 'NIKE抖音广州品牌旗舰店', label: 'NIKE抖音广州品牌旗舰店' },
  { value: 'NIKE抖音淮海潮流旗舰店', label: 'NIKE抖音淮海潮流旗舰店' },
  { value: 'NIKE抖音官方旗舰店', label: 'NIKE抖音官方旗舰店' },
  { value: 'JORDAN抖音官方旗舰店', label: 'JORDAN抖音官方旗舰店' },
  { value: 'NIKE门店小程序商城', label: 'NIKE门店小程序商城' },
  { value: 'NIKE兰州北环换季优惠店', label: 'NIKE兰州北环换季优惠店' },
  { value: 'NIKE成都双流换季优惠店', label: 'NIKE成都双流换季优惠店' }
]

export const PLATFORM_SOURCE_STATUS = [
  { value: 'JD', label: '京东' },
  { value: 'TM', label: '天猫' },
  { value: 'BS', label: '官网' },
  { value: 'ZD', label: '抖音' }
]

export const WORK_ORDER_STATUS = [
  { value: '1', label: '新建' },
  { value: '2', label: '处理中' },
  { value: '3', label: '已关闭' },
  { value: '4', label: '已作废' }
]
export const QUALITY_INSPECTION_RESULTS = [
  { value: 'A', label: 'A品' },
  { value: 'B', label: 'B品' },
  { value: 'C', label: 'C品' },
  { value: 'WTP', label: '退回待处理' }
]

export const DLP_RODER_RISK_WARNING = [
  { value: '少退', label: '少退' },
  { value: '召回失败', label: '召回失败' },
  { value: 'C品', label: 'C品' },
  { value: '假货', label: '假货' },
  { value: '虚假物流信息', label: '虚假物流信息' },
  { value: '重复物流单号', label: '重复物流单号' },
  { value: '无效物流单号', label: '无效物流单号' },
  { value: '退货地址非Nike仓库', label: '退货地址非Nike仓库' }
]

export const DLP_USER_LEVEL = [
  { value: 'A+', label: 'A+' },
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'D', label: 'D' },
  { value: 'E', label: 'E' },
  { value: 'New Member', label: 'New Member' }
]

export const CS_HANDLE_TYPE = [
  { value: '1', label: '入库' },
  { value: '2', label: '拒收' },
  { value: '4', label: '暂存' },
  { value: '3', label: '需补充材料' }
]
export const CS_HANDLE_SUB_TYPE = [
  { value: '101', label: '商品正常入库', parent: '1' },
  { value: '102', label: '顾客要求拆除环扣入库', parent: '1' },
  { value: '103', label: '吊牌与鞋盒问题入库', parent: '1' },
  { value: '104', label: '质量问题入库', parent: '1' },
  { value: '105', label: '货不对板入库-错发', parent: '1' },
  { value: '106', label: '货不对板入库-漏发', parent: '1' },
  { value: '107', label: '货不对板入库-来货问题', parent: '1' },
  { value: '108', label: '货不对板入库-小二强判', parent: '1' },
  { value: '109', label: '货不对板入库-品牌特批', parent: '1' },
  { value: '110', label: '优先退款入库', parent: '1' },
  { value: '111', label: '赠品入库', parent: '1' },
  { value: '112', label: '特殊问题入库', parent: '1' },
  { value: '201', label: '未错/漏发拒收', parent: '2' },
  { value: '202', label: '应收与实收不符拒收', parent: '2' },
  { value: '203', label: '无指令拒收', parent: '2' },
  { value: '204', label: '非Nike拒收', parent: '2' },
  { value: '205', label: '非Nike环扣拒收', parent: '2' },
  { value: '206', label: '影响二销拒收', parent: '2' },
  { value: '207', label: '换货无库存拒收', parent: '2' },
  { value: '208', label: '超7/超质保拒收', parent: '2' },
  { value: '209', label: '空包裹拒收', parent: '2' },
  { value: '210', label: '非本仓地址拒收', parent: '2' },
  { value: '211', label: '顾客要求拒收', parent: '2' },
  { value: '212', label: '疑似恶意订单拒收', parent: '2' },
  { value: '213', label: '特殊商品不支持七天拒收', parent: '2' },
  { value: '401', label: '绿通不符暂存', parent: '4' },
  { value: '402', label: '商城取消暂存', parent: '4' },
  { value: '403', label: '退回件查不到订单暂放', parent: '4' },
  { value: '404', label: '指令已完成暂存', parent: '4' },
  { value: '405', label: 'NBY暂存', parent: '4' },
  { value: '406', label: '非Nike暂存', parent: '4' },
  { value: '407', label: '赠品暂存', parent: '4' },
  { value: '301', label: '需补充材料', parent: '3' }
]
export const PACKAGE_TYPE = [
  { value: 'ALL', label: '全部' },
  { value: 'ABNORMAL', label: '异常件' },
  { value: 'NORMAL', label: '非异常件' }
]
export const TIME_RANGE = [
  { value: 'DAY', label: 'Daily' },
  { value: 'WEEK', label: 'Weekly' },
  { value: 'MONTH', label: 'Monthly' }
]
export const CHANNEL = [
  // { value: 'ALL', label: '全部' },
  { value: 'TM', label: 'Tmall' },
  { value: 'JD', label: 'JD' },
  { value: 'GW', label: 'Nike.com' },
  { value: 'DY', label: 'Douyin' },
  { value: 'NVS', label: 'NVS' }
]
export const GREEN_CHANNEL = [
  { value: 'ALL', label: '全部' },
  { value: 'Y', label: '绿通' },
  { value: 'N', label: '非绿通' }
]
